// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the middle of FilePreviewWindow's header, for a view's own switches (the document viewer's
// Page / Code / Side by side and page widths), so the file keeps the room a second bar would take.
// A view portals its bar here when it is given; it is null outside the window.

import {createContext} from 'react';

export const FilePreviewToolbarContext = createContext<HTMLElement | null>(null);
